import util from '@utils/util';
/**
     * 个人页模块 组件
     * biggestFans
     */
export default {
  name: 'biggestFans',
  props: {
    biggestFansList: Array,
    userInfo: Object,
    countryCode: String,
    target: String
  },
  data: function data() {
    return {
      listHeight: 0
    };
  },
  watch: {
    biggestFansList: {
      handler: function handler() {
        this.getListWrapHeight();
      },
      immediate: true
    }
  },
  methods: {
    // 获取贡献值
    getMedalLevel: function getMedalLevel(index) {
      return "medal medal-".concat(index);
    },
    getBigFansPersonalLink: function getBigFansPersonalLink(uid) {
      if (!uid) {
        return 'javascript:;';
      }
      var local = util.getI18nLocale();
      // 带参传递
      var json = {
        pathname: "/".concat(local, "/u/").concat(uid, "/index.html")
      };
      return util.directToPath(json, true);
    },
    directToBigFansPersonalLink: function directToBigFansPersonalLink(uid) {
      if (!uid) {
        return 'javascript:;';
      }
      var cc = util.getI18nLocale();
      return "".concat("".concat(window.location.protocol, "//").concat(window.location.host), "/", cc, "/u/").concat(uid, "/index.html").concat(window.location.search);
    },
    // 获取总高
    getListWrapHeight: function getListWrapHeight() {
      if (this.$refs.listWrap && this.$refs.listWrap.offsetHeight) {
        var height = this.$refs.listWrap.offsetHeight;
        this.listHeight = +height - 120;
      }
    }
  }
};